import React from "react";
import { observatoriesData } from "./ObservatoriesData";
import ObservatoryMap from "./ObservatoryMap";
import { Info } from "lucide-react";
import "../../css/company/observatories.css";
import { AuroraBackground } from "../components/AuroraBackground";

export const Observatories = () => {
  return (
    <div className="observatories-page aurora-background">
      <AuroraBackground particleCount={8} />
      
      {/* Header Section - Above All Columns */}
      <div className="observatories-header">
        <h1 className="observatories-title">{observatoriesData.title}</h1>
        {/* <p className="observatories-description">{observatoriesData.description}</p> */}
      </div>

      {/* Map Section with Overlayed Legend */}
      <div className="observatories-map-section">
        <div className="map-wrapper">
          {/* Info Icon with Tooltip */}
          <div className="map-info-icon" data-tooltip="TransAstra operates a global network of Sutter™ telescope systems for space domain awareness and asteroid detection. Our observatories are strategically positioned around the world to provide continuous coverage of the sky, detecting and tracking objects from Low Earth Orbit to cislunar space and beyond.">
            <Info className="info-icon" size={18} />
          </div>
          
          <ObservatoryMap observatories={observatoriesData.observatories} />
          
          {/* Observatory Status Legend - Overlayed on Map */}
          {/* <div className="observatory-legend">
            <h3>Status Legend</h3>
            <div className="legend-items">
              <div className="legend-item">
                <span className="status-indicator operational"></span>
                <span>Operational</span>
              </div>
              <div className="legend-item">
                <span className="status-indicator planned"></span>
                <span>Planned</span>
      </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};
